export default __webpack_public_path__ + "static/media/arrow-down.78567e62.svg";